import React from "react";
import { FormControl } from "react-bootstrap";
import ReactInputMask from "react-input-mask";
import LoadingInput from "../LoadingInput";
import { _Input } from "../Input";

import Text from "../Text";
import Page from "../Layout/Page";
import Row from "../Layout/Row";
import Column from "../Layout/Column";
import Button from "../Button";
import Modal from "../Modal";

import FilterClients from "../../views/AppViews/Clients/components/Filter";

/*
    validators: minLeght{3};notEmpty;emailPattern;phonePattern;cpfPattern;cnpjPattern
    filters: only:number|chars
    transform: upperCase|lowerCase
*/

export default (props) => {
  const [data, setData] = React.useState({});

  function onChange(field, event) {
    let { name: key, value } = event.target;

    const newData = { ...data };

    if (field.filters) {
      if (field.filters === "only:number") {
        value = value.replace(/\D+/g, "");
      } else if (field.filters === "only:chars") {
        value = value.replace(/\d+/g, "");
      }
    }
    if (field.validators) {
      const validators = field.validators.split(";");
      let errors = [];
      let spanErrors = [];
      for (let x = 0; x < validators.length; x++) {
        const valiador = validators[x];

        if (valiador === "notEmpty") {
          if (value.length === 0) {
            errors.push("o campo não pode ser nulo");
          }
        }

        if (valiador.includes("minLeght")) {
          const minLeght = parseInt(valiador.replace(/\D+/g, "") || 0);
          if (value.length < minLeght) {
            errors.push(`o campo precite ter ${minLeght} caracteres ou mais`);
          }
        }
        if (errors.length > 0) {
          const el = document.querySelector();
          for (let x in errors) {
            console.log(x);
          }
        } else {
        }
      }
    }
    if (field.transform) {
      if (field.transform === "upperCase") {
        value = value.toUpperCase();
      } else if (field.transform === "lowerCase") {
        value = value.toLowerCase();
      }
    }
    newData[key] = value;
    field.value = value;
    if (props.setData) {
      props.setData(newData);
    }
    setData(newData);
  }

  return (
    <React.Fragment>
      <form action="/" method="get" className="row">
        {props.fields.map((field, idx) => {
          const key = `form-${props.name}-field-${field.name}-${idx}`;

          if (field.validators) {
          }

          if (field.component) {
          }

          if (field.type === "select") {
            return (
              <FormControl required={field.required} as="select">
                {" "}
              </FormControl>
            );
          } else {
            if (field.mask) {
              return (
                <div className="col-md-4" key={key}>
                  <div className="form-group">
                    <div className="form-label">
                      <h4>{field.label}</h4>
                    </div>
                    <small>{field.helperText || ""}</small>
                    <ReactInputMask
                      mask={field.mask}
                      name={field.name}
                      value={field.value}
                      onChange={(e) => onChange(field, e)}
                      required={field.required}
                      placeholder={field.placeholder}
                      className="form-control"
                    />
                  </div>
                </div>
              );
            } else {
              return (
                <div className="col-md-4" key={key}>
                  <div className="form-group">
                    <div className="form-label">
                      <h4>{field.label}</h4>
                    </div>
                    <small>{field.helperText}</small>
                    <LoadingInput
                      name={field.name}
                      value={field.value}
                      onChange={(e) => onChange(field, e)}
                      required={field.required}
                      placeholder={field.placeholder}
                      className="form-control"
                    />
                  </div>
                </div>
              );
            }
          }
        })}
      </form>
    </React.Fragment>
  );
};

export function Form(props) {
  const ref = React.useRef(null);
  const [fields, setFields] = React.useState([]);
  const [options, setOptions] = React.useState({ useLayout: true });
  const [showFilterClients, setShowFilterClients] = React.useState(false);
  const [data, setData] = React.useState({});

  function onChange(e) {
    if (e.target) {
      e.name = e.target.name;
      e.value = e.target.value;
    }
    const dataUpdated = {
      ...data,
      [e.name]: e.value,
    };
    setData(dataUpdated);
    if (props.onChange) {
      props.onChange(dataUpdated);
    }
  }
  function onClick(field) {
    if (field.name === "client") {
      setShowFilterClients(true);
    }
  }
  function handleSetClient(client) {
    try {
      document.querySelector("[name=client]").value = client.name;
      setShowFilterClients(false);
      setTimeout(() => {
        onChange({ target: { name: "client", value: client.id } });
      }, 250);
    } catch (error) {}
  }
  function onSubmit(e) {
    e.preventDefault();
    const requiredFields = props.fields.filter((field) => field.required);

    if (requiredFields.length > 0) {
    }

    if (props.onSubmit) {
      props.onSubmit(data);
    }
  }
  function handleSetData() {
    const keys = Object.keys(props.data || {});
    if (keys.length > 0) {
      setTimeout(() => {
        for (let key of keys) {
          if (key === "id") {
            continue;
          }
          try {
            if (key === "phone_number") {
              console.debug(
                "phone_number",
                document.querySelector(`[name="${key}"`)
              );
              //.querySelector("input").value = props.data[key]
            } else {
              document.querySelector(`[name="${key}"`).value = props.data[key];
            }
          } catch (error) {
            console.debug(key, error);
          }
        }
        setData(props.data);
      }, 200);
    }
  }
  React.useEffect(handleSetData, [props.data]);
  function init() {
    if (props.fields) {
      setFields(props.fields);
    }
    if (props.options) {
      setOptions(props.options);
    }
  }
  React.useEffect(init, [ref.current]);

  if (options.useLayout) {
    return (
      <Page>
        <Modal
          title="Pesquisar Cliente"
          show={showFilterClients}
          onHide={() => setShowFilterClients(false)}
        >
          <FilterClients onClick={handleSetClient} />
        </Modal>

        <form onSubmit={onSubmit} ref={ref}>
          <Row>
            {fields.map((field, idx) => {
              if (field.label) {
                return (
                  <Column
                    col={options.fieldCol}
                    xs={options.fieldXs}
                    md={options.fieldMd}
                    lg={options.fieldLg}
                  >
                    <div className="form-group">
                      <div className="form-label">
                      </div>
                      <_Input
                        onClick={() => onClick(field)}
                        loading={props.loading}
                        onChange={onChange}
                        {...field}
                      />
                    </div>
                  </Column>
                );
              } else if (field.type === "component") {
                return <field.component />;
              } else {
                return (
                  <Column
                    col={options.fieldCol}
                    xs={options.fieldXs}
                    md={options.fieldMd}
                    lg={options.fieldLg}
                  >
                    <_Input
                      loading={props.loading}
                      onChange={onChange}
                      {...field}
                    />
                  </Column>
                );
              }
            })}
          </Row>
          <Row>
            <Column col="12 py-3">
              <div
                className={`d-flex justify-content-${
                  props.positinButton ? props.positinButton : "center"
                }`}
              >
                <Button
                  disabled={props.disabled || props.loading}
                  type="submit"
                  onClick={onSubmit}
                >
                  {props.btnLabel ? props.btnLabel : "Enviar"}
                </Button>
              </div>
            </Column>
          </Row>
        </form>
      </Page>
    );
  } else {
    return (
      <form ref={ref}>
        <Modal
          title="Pesquisar Cliente"
          show={showFilterClients}
          onHide={() => {}}
        >
          <FilterClients />
        </Modal>
        {fields.map((field, idx) => {
          if (field.label) {
            return (
              <div className="form-group">
                <div className="form-label">
                  <Text color="primary">{field.label}</Text>
                </div>
                <_Input {...field} />
              </div>
            );
          } else {
            return <_Input {...field} />;
          }
        })}
        <div
          className={`d-flex justify-content-${
            props.positinButton ? props.positinButton : "center"
          }`}
        >
          <Button type="submit" onClick={onSubmit}>
            {props.btnLabel ? props.btnLabel : "Enviar"}
          </Button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/Form/index.jsx